import { identifyUser, initializeErrorReporting } from '@bluearchive/ui-common';
import envConfig from '../config/env';

/**
 * This function is the default export for this module. It initializes error reporting and identifies the user if available.
 *
 * @param {Object} user - An object containing information about the user, if available.
 * @param {string} user.name - The name of the user.
 * @param {string} user.fullName - The full name of the user.
 */
export default function config(user) {
  const dsn = envConfig.dsn;
  const appID = envConfig.appId;
  const appPrefix = envConfig.appPrefix;
  const sampleRate = 1.0;
  const debug = envConfig.reportErrorsDebug;
  const env = envConfig.buildVersion;
  const buildEnv = envConfig.buildEnv;

  if (
    buildEnv === 'qa' ||
    buildEnv === 'qa2' ||
    buildEnv === 'stage' ||
    buildEnv === 'prod'
  ) {
    // Initialize error reporting with the retrieved values.
    initializeErrorReporting(
      appID,
      dsn,
      appPrefix,
      undefined,
      undefined,
      sampleRate,
      debug,
      env
    );

    // If a user is available, identify them using the "identifyUser" function.
    if (user) {
      identifyUser({ Name: user?.name, FullName: user?.fullName });
    }
  }
}
